import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { setSession, logout } = useAuth();
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      if (data.user.role !== "admin") {
        logout();
        toast.error("هذا الدخول مخصص لحساب الإدارة فقط");
        return;
      }
      setSession(data.token, data.user);
      toast.success("مرحبًا بك في لوحة الإدارة");
      nav("/admin");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="text-center mb-8">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--amber)] text-[#0B0F17] mb-3"><ShieldCheck size={28} /></span>
        <h1 className="font-head text-2xl font-black text-white">دخول الإدارة</h1>
        <p className="text-sm text-[var(--text-muted)] mt-1">صفحة مخصّصة لمدير المنصة فقط</p>
      </div>
      <form onSubmit={submit} className="ts-card p-6 space-y-4">
        <div>
          <label className="text-xs font-bold text-[var(--text-muted)] block mb-1.5">البريد الإلكتروني أو رقم الجوال</label>
          <input data-testid="admin-login-identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required
            className="w-full rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none" placeholder="admin@email.com" />
        </div>
        <div>
          <label className="text-xs font-bold text-[var(--text-muted)] block mb-1.5">كلمة المرور</label>
          <input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none" placeholder="••••••••" />
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="btn-amber w-full justify-center disabled:opacity-60">
          {loading ? "جارٍ الدخول..." : "دخول لوحة الإدارة"}
        </button>
      </form>
    </div>
  );
}
